import {
  Button,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Textarea,
} from '@commenda/kakashi';

interface ComposeStepProps {
  message: string;
  setMessage: (message: string) => void;
  selectedCount: number;
  onCancel: () => void;
  onReview: () => void;
  description?: React.ReactNode;
}

export const ComposeStep = ({
  message,
  setMessage,
  selectedCount,
  onCancel,
  onReview,
  description,
}: ComposeStepProps) => (
  <>
    <DialogHeader className="flex flex-col gap-xs items-start">
      <DialogTitle>Send Bulk Message</DialogTitle>
      <DialogDescription>
        {description ?? (
          <>
            Compose a message to send to {selectedCount} selected
            service request(s). The message will be sent as a thread message from
            each service request&apos;s assigned agent.
          </>
        )}
      </DialogDescription>
    </DialogHeader>

    <div className="py-xl px-2xl">
      <Textarea
        placeholder="Type your message here..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={6}
        className="resize-y"
      />
    </div>

    <DialogFooter>
      <Button variant="secondary" onClick={onCancel}>
        Cancel
      </Button>
      <Button
        variant="primary"
        onClick={onReview}
        disabled={!message.trim()}
      >
        Review
      </Button>
    </DialogFooter>
  </>
);
